import React from 'react';

import { Chip, Group, Stack, Text } from '@mantine/core';
import type { KiloClassListView } from 'types/generated';

interface ClassTimeSelectorProps {
  classInstances: KiloClassListView[];
  selectedId: string | null;
  onChange: (id: string) => void;
}

const ClassTimeSelector = ({
  classInstances,
  selectedId,
  onChange,
}: ClassTimeSelectorProps): JSX.Element => (
  <Stack spacing='xs'>
    <Text size='sm' weight={500} color='dimmed'>
      Select class time
    </Text>
    <Group spacing='xs'>
      {classInstances.map(instance => (
        <Chip
          key={instance.kiloClassId}
          value={instance.kiloClassId}
          checked={selectedId === instance.kiloClassId}
          onChange={() => onChange(instance.kiloClassId)}
          size='sm'
        >
          {(() => {
            const [h, m] = instance.startTime.split(':');
            const hour = parseInt(h, 10);
            return `${hour % 12 || 12}:${m} ${hour >= 12 ? 'PM' : 'AM'}`;
          })()}
        </Chip>
      ))}
    </Group>
  </Stack>
);

export default ClassTimeSelector;
